angular
  .module 'memberPortal'
  .controller 'WorkoutsCtrl', (
    $scope,
    $stateParams,
    workouts
  ) ->
    $scope.workouts = workouts

    $scope.getHash = ->
      $stateParams.hash || $stateParams.m
